module.exports = __webpack_public_path__ + "img/pdf-blue.8a2e6fe0.svg";